import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSenior = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M26.6 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M26.57 18a6 6 0 0 1 6 6v10h-12V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M13.4 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M34.07 34v-9h1v9zM10.497 16.533a3.021 3.021 0 1 0 6.006 0l.994-.106a4.02 4.02 0 1 1-7.994 0zM23.617 12.533a3.021 3.021 0 1 0 6.006 0l.994-.106a4.02 4.02 0 1 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M13.43 22a6 6 0 0 1 6 6v6h-12v-6a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M34.57 26.7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSenior);

export default ForwardRef;
